'use es6';

export default function getCookie(name) {
  var value = "; " + window.document.cookie;
  var splitCookies = value.split(';');

  if (splitCookies.length) {
    for (var i = 0; i < splitCookies.length; i++) {
      var parts = splitCookies[i].split('=');

      if (parts.length === 2 && parts[0].trim() === name) {
        return parts[1];
      }
    }
  }

  return null;
}